import { getBasePath } from 'utils/getBasePath';

// Navigation service for programmatic navigation outside React components

interface ErrorDetails {
    data?: any;
    config?: any;
    [key: string]: any;
}

interface StoredErrorDetails extends ErrorDetails {
    status: number;
    timestamp: string;
    url: string;
}

type NavigatorFunction = (path: string) => void;

// Error codes that should trigger error page navigation
type ErrorPageStatus = 502 | 503;

class NavigationService {
    private navigator: NavigatorFunction | null = null;

    setNavigator(navigator: NavigatorFunction): void {
        this.navigator = navigator;
    }

    navigate(path: string): void {
        if (this.navigator) {
            this.navigator(path);
        } else {
            // Fallback to window.location.href if navigator not set
            console.warn('NavigationService: Navigator not set, falling back to window.location.href');
            window.location.href = `${getBasePath()}${path}`;
        }
    }

    // Navigate to error page with console log preservation
    navigateToError(errorCode: ErrorPageStatus, errorDetails: ErrorDetails = {}): void {
        // Store error details for debugging
        const fullErrorDetails: StoredErrorDetails = {
            status: errorCode,
            timestamp: new Date().toISOString(),
            url: window.location.href,
            ...errorDetails,
        };

        sessionStorage.setItem('lastError', JSON.stringify(fullErrorDetails));

        // Navigate to error page
        this.navigate(`/error?code=${errorCode}`);
    }
}

// Export types for use in other files
export type { ErrorDetails, StoredErrorDetails, NavigatorFunction, ErrorPageStatus };

// Export singleton instance
export const navigationService = new NavigationService();
export default navigationService;
